"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.AccountNav = exports.AccountNavWrap = exports.AccountLink = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _styledSystem = require("styled-system");

var _Link = _interopRequireDefault(require("../Link"));

var _mediaQueries = _interopRequireDefault(require("../../styles/mediaQueries"));

var AccountLink = (0, _styled.default)(_Link.default)(function (_ref) {
  var space = _ref.theme.space;
  return {
    fontWeight: 'bold',
    marginRight: space.large,
    '&:last-of-type': {
      marginRight: '0'
    }
  };
}, (0, _styledSystem.variant)({
  variants: {
    slider: {
      fontSize: '2.2rem',
      lineHeight: '2.8rem',
      letterSpacing: '1px'
    },
    mega: _defineProperty({}, _mediaQueries.default.untilMedium, {
      display: 'none'
    })
  }
}));
exports.AccountLink = AccountLink;
var AccountNavWrap = (0, _styled.default)('div')(function (_ref2) {
  var _ref2$theme = _ref2.theme,
      space = _ref2$theme.space,
      colors = _ref2$theme.colors,
      globalNav = _ref2$theme.globalNav;
  return {
    padding: "".concat(space.xlarge, " 0"),
    borderBottom: globalNav.actionsWrapBorder,
    display: 'block',
    overflow: 'hidden',
    'a >span:first-of-type': {
      color: colors.white,
      '&:hover': {
        color: colors.white,
        borderColor: colors.white
      },
      nav: {
        justifyContent: 'center'
      }
    },
    'a:last-of-type': {
      marginRight: '0',
      'span:first-of-type': {
        '&::after': {
          content: 'none'
        }
      }
    }
  };
});
exports.AccountNavWrap = AccountNavWrap;
var AccountNav = (0, _styled.default)('nav')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'left'
}, function (_ref3) {
  var _a, _slider;

  var _ref3$theme = _ref3.theme,
      colors = _ref3$theme.colors,
      space = _ref3$theme.space,
      globalNav = _ref3$theme.globalNav,
      accountPrimaryLinks = _ref3.accountPrimaryLinks;
  return (0, _styledSystem.variant)({
    variants: {
      slider: (_slider = {
        padding: "".concat(space.xlarge, " 0"),
        display: 'block',
        overflow: 'hidden',
        borderBottom: globalNav.actionsWrapBorder
      }, _defineProperty(_slider, _mediaQueries.default.untilSmall, {
        justifyContent: accountPrimaryLinks ? 'center' : 'flex-start',
        textAlign: accountPrimaryLinks ? 'center' : 'left'
      }), _defineProperty(_slider, '>a', (_a = {
        position: 'relative',
        display: 'inline-block'
      }, _defineProperty(_a, _mediaQueries.default.untilSmall, {
        flexBasis: accountPrimaryLinks ? '50%' : '100%'
      }), _defineProperty(_a, '&:last-of-type', {
        marginRight: '0',
        'span:first-of-type': {
          '&::after': {
            content: 'none'
          }
        }
      }), _defineProperty(_a, '>span:first-of-type', {
        color: colors.white,
        '&:hover': {
          color: colors.white,
          borderColor: colors.white
        },
        nav: {
          justifyContent: 'center'
        }
      }), _defineProperty(_a, 'span:first-of-type::after', {
        content: accountPrimaryLinks ? '""' : 'none',
        position: 'absolute',
        right: "-".concat(space.medium),
        top: '50%',
        transform: 'translate(0, -50%)',
        width: '1px',
        height: '5rem',
        backgroundColor: colors.white,
        display: 'inline-block'
      }), _a)), _slider)
    }
  });
}, function (_ref4) {
  var _ref4$theme = _ref4.theme,
      colors = _ref4$theme.colors,
      globalNav = _ref4$theme.globalNav;
  return (0, _styledSystem.variant)({
    prop: 'variation',
    variants: {
      primary: {
        borderBottom: globalNav.primaryMenuAccountNavBorder,
        '>a': {
          '>span:first-of-type': {
            color: colors.primary,
            '&:hover': {
              color: colors.primary,
              borderColor: colors.primary
            }
          },
          'span:first-of-type::after': {
            backgroundColor: colors.primary
          }
        }
      }
    }
  });
});
exports.AccountNav = AccountNav;